import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCalculator, FiTrendingUp, FiDollarSign, FiArrowRight, FiCheck } = FiIcons;

const ROICalculator = () => {
  const [showResults, setShowResults] = useState(false);
  const [recommendations, setRecommendations] = useState([]);

  useEffect(() => {
    // Load Tally script
    const script = document.createElement('script');
    script.innerHTML = `var d=document,w="https://tally.so/widgets/embed.js",v=function(){"undefined"!=typeof Tally?Tally.loadEmbeds():d.querySelectorAll("iframe[data-tally-src]:not([src])").forEach((function(e){e.src=e.dataset.tallySrc}))};if("undefined"!=typeof Tally)v();else if(d.querySelector('script[src="'+w+'"]')==null){var s=d.createElement("script");s.src=w,s.onload=v,s.onerror=v,d.body.appendChild(s);}`;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <section id="roi" className="py-24 bg-gradient-to-br from-slate-gray to-dental-blue">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-clean-white mb-6">
            Discover Your Practice's{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-growth-green to-energy-coral">
              ROI Potential
            </span>
          </h2>
          <p className="text-xl text-clean-white opacity-90 max-w-4xl mx-auto leading-relaxed">
            Our interactive ROI calculator shows you exactly how EngageDent Ai can increase bookings, 
            cut no-shows, and grow your margins. Answer a few quick questions, and our AI will recommend 
            the products that best fit your practice's needs — with projected returns you can trust.
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto">
          {/* Tally Form Embed */}
          <motion.div
            className="bg-clean-white rounded-3xl p-8 shadow-2xl"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="flex items-center space-x-4 mb-8">
              <div className="w-12 h-12 bg-gradient-to-br from-dental-blue to-ai-teal rounded-xl flex items-center justify-center">
                <SafeIcon icon={FiTrendingUp} className="text-clean-white text-xl" />
              </div>
              <h3 className="text-2xl font-bold text-slate-gray">Calculate Your ROI</h3>
            </div>

            <div className="w-full">
              <iframe 
                data-tally-src="https://tally.so/embed/nr9NBl?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1" 
                loading="lazy" 
                width="100%" 
                height="477" 
                frameBorder="0" 
                marginHeight="0" 
                marginWidth="0" 
                title="Dental Practice AI ROI Audit"
                className="rounded-xl"
              ></iframe>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ROICalculator;